import { Col, Row, Typography, useTheme } from "@commonlibs";
import clsx from "clsx";
import { AttributeCardRoot, AttributeSkeleton } from "./AttributeCard.styles";
import { AttributeCardProps } from "./AttributeCard.types";
import Balance from "ui/wallet/component/display/Balance/Balance";
import InfoPopover from "../../feedback/InfoPopover/InfoPopover";

const AttributeCard = ({ attribute, value, className, isLoading = false, style, tooltipText }: AttributeCardProps): JSX.Element => {
    const { spacing } = useTheme();
    // skipcq: JS-0415
    return (
        /* skipcq: JS-0415 */
        <AttributeCardRoot style={style} className={clsx("attribute-card", attribute, className)}>
            <Col justifyContent="center" alignItems="center" gap={spacing[2]}>
                <AttributeSkeleton loading={isLoading}>
                    <Row
                        css={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                        }}
                    >
                        <Typography variant="body3Strong" color="gray.300" textAlign="center">
                            {attribute}
                        </Typography>
                        {tooltipText && (
                            <InfoPopover text={tooltipText} />
                        )}
                    </Row>
                </AttributeSkeleton>
                <AttributeSkeleton loading={isLoading}>
                    <Balance balance={value} variant="h4Strong" color="gray.600" textAlign="center" />
                </AttributeSkeleton>
            </Col>
        </AttributeCardRoot>
    );
};

export default AttributeCard;
